/* eslint-disable */
import StepBase from "../../common/StepBase";
import Helper from "../../common/Helper";

class StepDistance extends StepBase {
  constructor(scene) {
    super(scene);

    this.setupCamera();
    this.setupMeshes();
  }

  //------------------------------------
  // Camera
  //------------------------------------
  setupCamera() {
    this.cameraRotationSpeed = -0.002;
    this.cameraPosition = new BABYLON.Vector3(0, 0, 0);
    this.cameraTarget = new BABYLON.Vector3(0, 0, 0);
  }

  //------------------------------------
  // Mesh
  //------------------------------------
  setupMeshes() {
    this.meshList.moon = this.scene.getMeshByID(Helper.getPlanetName(0));
    this.meshList.mars = this.scene.getMeshByID(Helper.getPlanetName(1));
    this.meshList.venus = this.scene.getMeshByID(Helper.getPlanetName(2));
    this.meshList.jupiter = this.scene.getMeshByID(Helper.getPlanetName(3));
    this.meshList.saturn = this.scene.getMeshByID(Helper.getPlanetName(4));

    this.meshList.moon.position.y = Helper.getPlanetPosition(0);
    this.meshList.mars.position.y = Helper.getPlanetPosition(1);
    this.meshList.venus.position.y = Helper.getPlanetPosition(2);
    this.meshList.jupiter.position.y = Helper.getPlanetPosition(3);
    this.meshList.saturn.position.y = Helper.getPlanetPosition(4);
  }

  //------------------------------------
  // setting
  //------------------------------------
  changeDistance(distance) {
    let y = Helper.getPlanetPosition(distance);
    this.cameraPosition = new BABYLON.Vector3(0, y / 2, y * 2 + 3);
    this.cameraTarget = new BABYLON.Vector3(0, y / 2, 0);
  }
}
export default StepDistance;
